import type { ChatMessage } from "../components/chat/ChatInterface";

export type DashboardUiTurnResponse = {
  message?: string;
  role?: ChatMessage["role"];
  error?: string;
};

export type PostDashboardUiTurnOptions = {
  turn: string;
  params?: Record<string, string | number | boolean>;
  uiRole?: Extract<ChatMessage["role"], "assistant" | "error">;
};

export async function postDashboardUiTurn(
  url: string,
  csrfToken: string,
  options: PostDashboardUiTurnOptions,
): Promise<DashboardUiTurnResponse | null> {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({
        turn: options.turn,
        params: options.params ?? {},
        ui_role: options.uiRole ?? "assistant",
      }),
    });

    const data = (await response.json()) as DashboardUiTurnResponse;
    if (!response.ok) {
      return { error: data.error ?? "Request failed" };
    }
    return data;
  } catch {
    return null;
  }
}
